import { ValueOf } from '../utilities/types';

const reportStatuses = {
  LOADING: 'loading',
  READY: 'ready',
  FAILED: 'failed',
} as const;
export type ReportStatuses = ValueOf<typeof reportStatuses>;

export const reportStatusesLabels: Record<ReportStatuses, string> = {
  [reportStatuses.LOADING]: 'Loading',
  [reportStatuses.READY]: 'Ready',
  [reportStatuses.FAILED]: 'Failed',
};

export const reportStatusesChoices = [
  reportStatuses.LOADING,
  reportStatuses.READY,
  reportStatuses.FAILED,
].map((id) => ({ id, name: reportStatusesLabels[id] }));

export default reportStatuses;
